import { useState, useEffect, useCallback } from 'react'

export function CustomCursor() {
  const [position, setPosition] = useState({ x: 0, y: 0 })
  const [hovering, setHovering] = useState(false)
  const [visible, setVisible] = useState(false)

  const updatePosition = useCallback((e: MouseEvent) => {
    setPosition({ x: e.clientX, y: e.clientY })
  }, [])

  useEffect(() => {
    if (typeof window === 'undefined') return
    const isCoarse = window.matchMedia('(pointer: coarse)').matches
    if (isCoarse) return

    setVisible(true)
    window.addEventListener('mousemove', updatePosition)

    const interactive = 'a, button, [role="button"], input, textarea, select'
    const handleMouseEnter = () => setHovering(true)
    const handleMouseLeave = () => setHovering(false)

    document.querySelectorAll(interactive).forEach((el) => {
      el.addEventListener('mouseenter', handleMouseEnter)
      el.addEventListener('mouseleave', handleMouseLeave)
    })

    return () => {
      window.removeEventListener('mousemove', updatePosition)
      document.querySelectorAll(interactive).forEach((el) => {
        el.removeEventListener('mouseenter', handleMouseEnter)
        el.removeEventListener('mouseleave', handleMouseLeave)
      })
    }
  }, [updatePosition])

  if (!visible) return null

  return (
    <>
      <div
        className="fixed top-0 left-0 w-4 h-4 pointer-events-none z-[9999] mix-blend-difference"
        style={{
          transform: `translate(${position.x}px, ${position.y}px) translate(-50%, -50%)`,
        }}
      >
        <div
          className={`rounded-full bg-accent transition-all duration-200 ${
            hovering ? 'w-3 h-3 scale-150 shadow-glow' : 'w-2 h-2'
          }`}
        />
      </div>
      <div
        className="fixed top-0 left-0 w-10 h-10 rounded-full border-2 border-primary/50 pointer-events-none z-[9998] transition-all duration-150"
        style={{
          transform: `translate(${position.x}px, ${position.y}px) translate(-50%, -50%)`,
          width: hovering ? 48 : 40,
          height: hovering ? 48 : 40,
        }}
      />
    </>
  )
}
